import PropTypes from 'prop-types';
import { NumericalInfo } from '../../../../core/components/NumericalInfo';
import { Delta } from '../../../../core/components/NumericalInfo/components/Delta';
import { useTranslation } from 'react-i18next';
import { Card } from '../../../../core/components/Card';
import { useEffect, useMemo, useState } from 'react';
import { millifyNumber } from '../../../../utils/millify-number';

export const NumericalInfoWithDelta = ({ data, sx, name, valueKey }) => {
  const { t } = useTranslation();
  const [tableData, setData] = useState(null);
  const isPositive = useMemo(() => data?.percentage >= 0, [data, valueKey]);

  useEffect(() => {
    if (data)
      setData({
        data: millifyNumber(data[valueKey]),
        delta: data.percentage < 1000 ? `${data.percentage}%` : `${millifyNumber(data.percentage)}%`
      });
  }, [data, valueKey, name]);

  return (
    <Card sx={{ ...sx }}>
      <NumericalInfo
        data={tableData?.data || 0}
        footer={<Delta isPositive={isPositive} value={tableData?.delta || '0.00%'} />}
        noSeparator
        title={t(`telemetry.${name}`)}
      />
    </Card>
  );
};

NumericalInfoWithDelta.propTypes = {
  data: PropTypes.object,
  sx: PropTypes.object,
  name: PropTypes.string,
  valueKey: PropTypes.string
};

export default NumericalInfoWithDelta;
